import { render, staticRenderFns } from "./ProblemWithConservation.vue.js?vue&type=template&id=14bdaf5a!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProblemWithConservation.vue?vue&type=template&id=14bdaf5a"
import script from "./ProblemWithConservation.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProblemWithConservation.vue?vue&type=script&lang=js"
export * from "./ProblemWithConservation.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProblemWithConservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports